import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { getCateringOrder, updateCateringOrderStatus, createUpdateOrder, getDepartment, getCateringProduct, getAdminLocation, getAllCompanyNameQuery, getCateringOrderStatus, cateringOrderWithoutMeeting, getCanteenUser, cancelCatering, updateCateringOrderMetadata, getTranslationWithPageName, searchADColleague, getCateringField, cancelOrder, } from "../../services/ApiServices"
import { appName, emailRegex, maxCateringProductQty, maxExternalAttendees, maxInternalAttendees, minCateringProductQty, minExternalAttendees, minInternalAttendees } from "../../const"
import { changeAllCateringOrderStatusValue, changeAllDepartmentValue, changeAllLocationValue } from "../../store/slices/APIResponseSlice"
import { convertRespArrToLabelObject, getDynamicLabel, handleError } from "../../utils/helpers"
import { changeOrderDetailsTranslationValue } from "../../store/slices/TranslationSlice.ts"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { PAGE_NAME } from "../../utils/pageName.ts"
import { confirmAlert } from "react-confirm-alert"
import { InputMask } from "@react-input/mask"
import { Tooltip } from "react-tooltip"
import { toast } from "react-hot-toast"
import CreatableSelect from "react-select/creatable"
import ReactDatePicker from "react-datepicker"
import SunEditor from "suneditor-react"
import moment from "moment/moment"
import Select from "react-select"
import "./OrderDetails.css"

import Loader from "../Loader/Loader"

// ==== Imported Image ====
import iconEdit from "../../assets/img/icon-edit.svg"
import iconClose from "../../assets/img/icon-close.svg"
import iconPin from "../../assets/img/icon-pin.svg"
import iconUsers from "../../assets/img/icon-users.svg"
import iconUser from "../../assets/img/icon-user.svg"
import iconClock from "../../assets/img/icon-clock.svg"
import iconAdd from "../../assets/img/icon-add.svg"
import iconTrash from "../../assets/img/icon-trash.svg"
import iconArrow from "../../assets/img/icon-arrow-down.svg"
import iconNotStarted from "../../assets/img/icon-not-started.svg"
import iconInProgress from "../../assets/img/icon-in-progress.svg"
import iconCompleted from "../../assets/img/icon-completed.svg"
import iconOrderNumber from "../../assets/img/icon-order-number.svg"

export default function OrderDetails() {
  const orderDetailsTranslation = useSelector((state) => state.Translation.OrderDetailsTranslation)
  // const allCanteenUsers = useSelector((state) => state?.APIResponse?.allCanteenUsers)
  const allDepartments = useSelector((state) => state?.APIResponse?.AllDepartment)
  const allLocations = useSelector((state) => state?.APIResponse?.AllLocations)
  const AllCateringOrderStatus = useSelector((state) => state?.APIResponse?.AllCateringOrderStatus)

  // ============ Local States ============
  const [isLoading, setIsLoading] = useState(false)
  const [allCanteenUsers, setAllCanteenUsers] = useState([])
  const [isUserSearchLoading, setIsUserSearchLoading] = useState(false)
  const [isSaveCanteenLoading, setIsSaveCanteenLoading] = useState(false)
  const [orderDetails, setOrderDetails] = useState({})
  const [cateringAllProduct, setCateringAllProduct] = useState([])
  const [allCompanyResponse, setAllCompanyResponse] = useState([])
  const [allCateringFields, setAllCateringFields] = useState([])

  const [error, setError] = useState({ Status: false, Indexs: [] })

  const [editCanteenUsersStatus, setEditCanteenUsersStatus] = useState(false)
  const [deliveryOrderUsers, setDeliveryOrderUsers] = useState([])
  const [pickupTime, setPickUpTime] = useState(moment().add(30, "m").format("HH:mm"))
  const [inputDate, setInputDate] = useState(moment().format("YYYY-MM-DD"))
  const [updatedTitle, setUpdatedTitle] = useState("")
  const [updatedOrderByName, setUpdatedOrderByName] = useState("")
  const [updatedOrderByEmail, setUpdatedOrderByEmail] = useState("")
  const [updatedOrderByPhone, setUpdatedOrderByPhone] = useState("")
  const [editOrderProductStatus, setEditOrderProductStatus] = useState(false)
  const [selectedDepartment, setSelectedDepartment] = useState({})
  const [selectedDeliveryMethod, setSelectedDeliveryMethod] = useState("Delivery")
  const [updatedInternalAttendees, setUpdatedInternalAttendees] = useState(0)
  const [updatedExternalAttendees, setUpdatedExternalAttendees] = useState(0)
  const [userSearch, setUserSearch] = useState("")
  const [searchInputCardStatus, setSearchInputCardStatus] = useState(false)
  const [colleaguesList, setColleaguesList] = useState([])
  const [updatedSharedComment, setUpdatedSharedComment] = useState("")
  const [updatedInternalComment, setUpdatedInternalComment] = useState("")
  const [updatedProductList, setUpdatedProductList] = useState([])
  const [invoiceInternal, setInvoiceInternal] = useState(true)
  const [invoiceExternalDetails, setInvoiceExternalDetails] = useState({
    CompanyName: "",
    Address: "",
    Zip: "",
    CVR: "",
    Att: "",
    Mail: ""
  })
  const [companyQueryString, setCompanyQueryString] = useState("")
  const [inputAmount, setInputAmount] = useState("")
  const [fieldValues, setFieldValues] = useState([])
  const [timeWhenOpen, setTimeWhenOpen] = useState(moment().add(30, "m").format("HH:mm"))
  const [selectedPath, setSelectedPath] = useState([])

  const meetingLocation = useMemo(() => {
    if (allLocations && allLocations?.length > 0 && orderDetails?.Meeting?.MeetingRooms && orderDetails?.Meeting?.MeetingRooms[0]?.Location) {
      return allLocations.find((d) => d?.Id === orderDetails?.Meeting?.MeetingRooms[0]?.Location?.Id)
    } else {
      return {}
    }
  }, [allLocations, orderDetails])

  const { orderId } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const costcenterRef = useRef()
  const deliveryRef = useRef()
  const orderBySearch = useRef()
  const containerRef = useRef(null)

  const updatedPrice = useCallback(() => {
    const total = updatedProductList && updatedProductList?.length > 0
      ? updatedProductList?.map((d) => d?.NumberOfItems * d?.Product?.Price)?.reduce((a, b) => a + b)?.toFixed(2)
      : "00"
    return total
  }, [updatedProductList])

  const discountOrderDetails = useMemo(() => {
    return updatedProductList?.map((order) => {
      let totalPrice = order?.Product?.Price * order?.NumberOfItems
      let discountPercentage = order?.DiscountPercentage ? parseFloat(order?.DiscountPercentage) : 0
      let discountAmount = (discountPercentage / 100) * totalPrice
      let finalPrice = totalPrice - discountAmount

      return {
        ...order,
        TotalPrice: totalPrice,
        DiscountAmount: discountAmount,
        FinalPrice: finalPrice
      }
    })
  }, [updatedProductList])

  // Calculate sum of DiscountAmount using useMemo
  const totalDiscountAmount = useMemo(() => {
    return (discountOrderDetails.reduce((sum, order) => sum + order?.DiscountAmount, 0)).toFixed(2)
  }, [discountOrderDetails])

  // To Set Discount Amount
  useEffect(() => {
    setInputAmount(totalDiscountAmount)
  }, [totalDiscountAmount])

  const resetSearchInput = (cardStatus) => {
    setSearchInputCardStatus(cardStatus)
    setUserSearch("")
    setColleaguesList([])
  }

  const getNewDiscountAmount = useCallback((order) => {
    const totalPrice = (order?.Product?.Price ?? 0) * (order?.NumberOfItems ?? 0)
    const discountPercentage = order?.DiscountPercentage ? parseFloat(order?.DiscountPercentage) : 0
    let discountAmount = ((discountPercentage / 100) * totalPrice).toFixed(2)

    return {
      DiscountAmount: discountAmount,
      FinalPrice: discountAmount ? (totalPrice - discountAmount).toFixed(2) : order?.Price
    }
  }, [])

  const resetDeliveryGroupState = () => {
    setDeliveryOrderUsers(orderDetails?.CanteenUsers?.map((d) => d?.Id))
    setUpdatedOrderByName(orderDetails?.OrderedByName)
    setUpdatedOrderByEmail(orderDetails?.OrderedByEmail)
    setUpdatedOrderByPhone(orderDetails?.OrderedByPhone)
    resetSearchInput(false)
  }

  const resetUpdatedItemGroupState = (orderDetails) => {
    const updatedProdList = ([
      ...[...orderDetails?.ProductOrders]?.map((d) => ({
        ...d,
        DeliveryHour: d?.DeliveryHour ?? moment(orderDetails?.Meeting?.Start).format("HH"),
        DeliveryMinute: d?.DeliveryMinute ?? moment(orderDetails?.Meeting?.Start).format("mm"),
      })),
      ...[...orderDetails?.ProductOtherOrders]?.map((d) => ({
        ...d,
        DeliveryHour: d?.DeliveryHour ?? moment(orderDetails?.Meeting?.Start).format("HH"),
        DeliveryMinute: d?.DeliveryMinute ?? moment(orderDetails?.Meeting?.Start).format("mm"),
      }))
    ])

    const cateringOrders = updatedProdList?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))

    setUpdatedProductList(cateringOrders?.map((order) => ({
      ...order,
      DiscountAmount: getNewDiscountAmount(order)?.DiscountAmount,
      FinalPrice: getNewDiscountAmount(order)?.FinalPrice,
    })))
    setSelectedDepartment(orderDetails?.Department?.Id ? orderDetails?.Department : {})
    setSelectedDeliveryMethod(orderDetails?.DeliveryMethod === "Pickup" ? orderDetails?.DeliveryMethod : "Delivery")
    setUpdatedInternalAttendees(orderDetails?.NumberOfPeople)
    setUpdatedExternalAttendees(orderDetails?.ExternalAttendeesPeoples)
    setUpdatedTitle(orderDetails?.Title)
    // setUpdatedSharedComment(orderDetails?.Comment !== null ? orderDetails?.Comment : "")
    setUpdatedSharedComment(orderDetails?.CommentHtml !== null ? orderDetails?.CommentHtml : orderDetails?.Comment !== null ? orderDetails?.Comment : "")
    // setUpdatedInternalComment(orderDetails?.InternalComment !== null ? orderDetails?.InternalComment : "")
    setUpdatedInternalComment(orderDetails?.InternalCommentHtml !== null ? orderDetails?.InternalCommentHtml : orderDetails?.InternalComment !== null ? orderDetails?.InternalComment : "")
    setInvoiceInternal(orderDetails?.InvoiceInternal ? orderDetails?.InvoiceInternal : false)
    setInvoiceExternalDetails({
      CompanyName: orderDetails?.InvoiceExternalDetails?.CompanyName,
      Address: orderDetails?.InvoiceExternalDetails?.Address,
      Zip: orderDetails?.InvoiceExternalDetails?.Zip,
      CVR: orderDetails?.InvoiceExternalDetails?.CVR,
      Att: orderDetails?.InvoiceExternalDetails?.Att,
      Mail: orderDetails?.InvoiceExternalDetails?.Mail
    })
  }

  const handleDeleteOrder = (data, i) => {
    setUpdatedProductList((prev) => prev?.filter((d) => d !== data))
  }

  // ============================================================================================
  const handleDeliveryTimeChange = (time, index) => {
    let arr = [...updatedProductList]

    setError((prev) => ({ ...prev, Indexs: prev?.Indexs?.filter((i) => i !== index) }))

    // /^(?:[01]\d|2[0-3]):[0-5]\d$/
    const checkLen0 = () => {
      if (time?.length === 0) {
        arr = arr?.map((p, i) => ({
          ...p,
          DeliveryHour: i === index ? "" : p?.DeliveryHour,
          DeliveryMinute: i === index ? "" : p?.DeliveryMinute
        }))
      }
    }
    const checkLen1 = () => {
      if (time?.length === 1) {
        if ((/^[0-2]$/).test(time)) {
          // position 1
          arr = arr?.map((p, i) => ({
            ...p,
            DeliveryHour: i === index ? time?.slice(0, 1) : p?.DeliveryHour,
            DeliveryMinute: i === index ? "" : p?.DeliveryMinute
          }))
        } else {
          checkLen0()
        }
      }
    }
    const checkLen2 = () => {
      if (time?.length === 2) {
        if ((/^(?:[01]\d|2[0-3])$/).test(time)) {
          // position 2
          arr = arr?.map((p, i) => ({
            ...p,
            DeliveryHour: i === index ? time?.slice(0, 2) : p?.DeliveryHour,
            DeliveryMinute: i === index ? "" : p?.DeliveryMinute
          }))
        } else {
          checkLen1()
        }
      }
    }
    const checkLen4 = () => {
      if (time?.length === 4) {
        if ((/^(?:[01]\d|2[0-3]):[0-5]$/).test(time)) {
          // position 4
          arr = arr?.map((p, i) => ({
            ...p,
            DeliveryHour: i === index ? time?.slice(0, 2) : p?.DeliveryHour,
            DeliveryMinute: i === index ? time?.slice(3, 4) : p?.DeliveryMinute
          }))
        } else {
          checkLen2()
        }
      }
    }
    const checkLen5 = () => {
      if (time?.length === 5) {
        if ((/^(?:[01]\d|2[0-3]):[0-5]\d$/).test(time)) {
          // position 5
          arr = arr?.map((p, i) => ({
            ...p,
            DeliveryHour: i === index ? time?.slice(0, 2) : p?.DeliveryHour,
            DeliveryMinute: i === index ? time?.slice(3, 5) : p?.DeliveryMinute
          }))
        } else {
          checkLen4()
        }
      }
    }

    checkLen0()
    checkLen1()
    checkLen2()
    checkLen4()
    checkLen5()

    setUpdatedProductList(arr)
  }

  const handleOnBlur = (time, index) => {
    if (time?.length === 1) {
      handleDeliveryTimeChange("0" + time + ":00", index)
    }
    if (time?.length === 2) {
      handleDeliveryTimeChange(time + ":00", index)
    }
    if (time?.length === 4) {
      handleDeliveryTimeChange(time?.slice(0, 2) + ":0" + time?.slice(3, 4), index)
    }
  }
  // ============================================================================================

  const handleFieldChange = (fieldId, newValue) => {
    setFieldValues((prevValues) =>
      (prevValues ?? [])?.map((item) =>
        item?.FieldId === fieldId ? { ...item, Value: newValue } : item
      )
    )
  }

  const addRow = () => {
    setUpdatedProductList((prev) => ([
      ...prev,
      {
        Product: {
          Id: 0,
          Name: "",
          Notes: "",
          Price: 0,
        },
        NumberOfItems: "",
        DiscountPercentage: "",
        DiscountAmount: 0,
        DeliveryHour: orderDetails?.Meeting?.Id ? selectedDeliveryMethod === "Delivery" ? moment(orderDetails?.Meeting?.Start).format("HH") : "" : "",
        DeliveryMinute: orderDetails?.Meeting?.Id ? selectedDeliveryMethod === "Delivery" ? moment(orderDetails?.Meeting?.Start).format("mm") : "" : "",
        // DeliveryHour: moment(orderDetails?.Meeting?.Id ? orderDetails?.Meeting?.Start : moment(timeWhenOpen, "HH:mm")).format("HH"),
        // DeliveryMinute: moment(orderDetails?.Meeting?.Id ? orderDetails?.Meeting?.Start : moment(timeWhenOpen, "HH:mm")).format("mm"),
      }
    ]))
  }

  const getDetails = async (orderId) => {
    if (orderId) {
      setIsLoading(true)
      await getCateringOrder(orderId).then((orderResponse) => {
        if (typeof orderResponse !== "string" && orderResponse?.Id !== undefined && typeof orderResponse === "object") {
          const cateringData = ({
            ...orderResponse,
            ProductOrders: orderResponse?.ProductOrders?.map((d) => ({
              ...d,
              DeliveryHour: d?.DeliveryHour === null ? "" : d?.DeliveryHour < 10 ? `0${d?.DeliveryHour}` : `${d?.DeliveryHour}`,
              DeliveryMinute: d?.DeliveryMinute === null ? "" : d?.DeliveryMinute < 10 ? `0${d?.DeliveryMinute}` : `${d?.DeliveryMinute}`,
            })),
            ProductOtherOrders: orderResponse?.ProductOtherOrders?.map((d) => ({
              DeliveryHour: d?.DeliveryHour === null ? "" : d?.DeliveryHour < 10 ? `0${d?.DeliveryHour}` : `${d?.DeliveryHour}`,
              DeliveryMinute: d?.DeliveryMinute === null ? "" : d?.DeliveryMinute < 10 ? `0${d?.DeliveryMinute}` : `${d?.DeliveryMinute}`,
              NumberOfItems: d?.NumberOfItems,
              DiscountPercentage: d?.DiscountPercentage,
              Product: { Id: d?.Id, Name: d?.Name, Notes: d?.Name, Price: d?.Price }
            }))
          })
          const sortProdTime = ({
            ...cateringData,
            ProductOrders: cateringData?.ProductOrders?.length > 0
              ? cateringData?.ProductOrders?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
              : [],
            ProductOtherOrders: cateringData?.ProductOtherOrders?.length > 0
              ? cateringData?.ProductOtherOrders?.sort((a, b) => Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`))
              : []
          })
          const replacingCanceledOrderObject = {
            ...sortProdTime,
            OrderStatus: sortProdTime?.IsCancelled ? AllCateringOrderStatus.find((data) => data?.Id === 12) : sortProdTime?.OrderStatus
          }
          setOrderDetails(replacingCanceledOrderObject)
          GetCateringProduct(orderResponse)
          setDeliveryOrderUsers(orderResponse?.CanteenUsers?.map((d) => d?.Id))
          resetUpdatedItemGroupState(sortProdTime)
          setPickUpTime(orderResponse?.Id ? moment(`${orderResponse?.DeliveryHour}:${orderResponse?.DeliveryMinute}`, "HH:mm").format("HH:mm") : moment().add(30, "m").format("HH:mm"))
          setInputDate(moment(orderResponse?.DeliveryDate).format("YYYY-MM-DD"))
          setUpdatedOrderByName(orderResponse?.OrderedByName ? orderResponse?.OrderedByName : "")
          setUpdatedOrderByEmail(orderResponse?.OrderedByEmail ? orderResponse?.OrderedByEmail : "")
          setUpdatedOrderByPhone(orderResponse?.OrderedByPhone ? orderResponse?.OrderedByPhone : "")
        } else if (typeof orderResponse === "string") {
          toast.error(orderResponse)
        } else if (orderResponse?.ExceptionMessage) {
          toast.error(orderResponse?.ExceptionMessage)
        }
      }).catch((error) => {
        handleError(error)
      }).finally(() => {
        setIsLoading(false)
      })
    } else {
      setOrderDetails({})
      toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnOrderIdIsMissing, "OrderId is Missing!"))
    }
    return
  }

  const GetCateringProduct = (response) => {
    const data = {
      locationId: response?.Meeting?.MeetingRooms?.length > 0 ? response?.Meeting?.MeetingRooms[0]?.Location?.Id : response?.Location?.Id,
      date: response?.Meeting?.Start ? moment(response?.Meeting?.Start).format("YYYY-MM-DD") : moment(response?.DeliveryDate).format("YYYY-MM-DD"),
      startTimeMeetingHour: response?.Meeting?.Start ? moment(response?.Meeting?.Start).format("HH") : response?.DeliveryHour,
      startTimeMeetingMinute: response?.Meeting?.Start ? moment(response?.Meeting?.Start).format("mm") : response?.DeliveryMinute,
      endTimeMeetingHour: response?.Meeting?.End ? moment(response?.Meeting?.End).format("HH") : response?.DeliveryHour,
      endTimeMeetingMinute: response?.Meeting?.End ? moment(response?.Meeting?.End).format("mm") : response?.DeliveryMinute,
    }

    // if (data?.locationId && data?.date && data?.startTimeMeetingHour && data?.startTimeMeetingMinute && data?.endTimeMeetingHour && data?.endTimeMeetingMinute) {
    getCateringProduct(data).then((resp) => {
      let arr = []
      if (resp?.length > 0) {
        for (let i = 0; i < resp.length; i++) {
          for (let j = 0; j < resp[i].Products.length; j++) {
            arr.push({
              Name: resp[i].Products[j].Name,
              Id: resp[i].Products[j].Id,
              Notes: resp[i].Products[j].Notes,
              Price: resp[i].Products[j].Price,
            })
          }
        }
      }
      setCateringAllProduct(arr)
    }).catch((error) => {
      setCateringAllProduct([])
      handleError(error)
    })
    // }
  }

  const UpdateCateringOrderStatus = (statusId) => {
    if (statusId) {
      setIsLoading(true)
      updateCateringOrderStatus(orderDetails?.Id, statusId).then(async (response) => {
        if (!response) {
          await getDetails(orderId)
          toast.success(getDynamicLabel(orderDetailsTranslation?.msgSuccessOrderUpdated, "Order Updated Successfully."))
        } else {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnLooksLikeAnError, "Looks like an Error!"))
        }
      }).catch((error) => {
        handleError(error)
      }).finally(() => {
        setIsLoading(false)
      })
    }
  }

  const CancelOrder = async () => {
    if (orderDetails?.Id) {
      const response = await cancelOrder(orderDetails?.Id)
      if (!response) {
        toast.success(getDynamicLabel(orderDetailsTranslation?.msgSuccessOrderCancelled, "Order cancelled successfully."))
        navigate("/")
      } else {
        await getDetails(orderId)
        handleError(response)
      }
    }
    return
  }

  const scrollToDiv = () => {
    const prodList = document.getElementById("prod-list")
    prodList && prodList?.scrollIntoView()
  }

  const SaveWithoutMeeting = async () => {
    const data = {
      "DepartmentId": editOrderProductStatus ? selectedDepartment?.Id : orderDetails?.Department?.Id,
      "Responsible": deliveryOrderUsers,
      // "NumberOfPeople": 0,
      // "ExternalAttendeesPeoples": 0,
      "Products": editOrderProductStatus
        ? updatedProductList?.filter((data) => cateringAllProduct?.filter((d) => d?.Id === data?.Product?.Id).length !== 0 && data?.NumberOfItems > 0)?.map((d) => {
          return {
            ProductId: d?.Product.Id,
            NumberOfItems: d?.NumberOfItems,
            DiscountPercentage: d?.DiscountPercentage,
            DeliveryHour: d?.DeliveryHour,
            DeliveryMinute: d?.DeliveryMinute
          }
        })
        : orderDetails?.ProductOrders?.map((d) => {
          return {
            ProductId: d.Product.Id,
            NumberOfItems: d.NumberOfItems,
            DiscountPercentage: d?.DiscountPercentage,
            DeliveryHour: d?.DeliveryHour,
            DeliveryMinute: d?.DeliveryMinute
          }
        }),
      "ProductsOther": editOrderProductStatus
        ? updatedProductList?.filter((data) => data?.Product?.Name.trim() !== "" && cateringAllProduct?.filter((d) => d?.Id === data?.Product?.Id).length === 0 && data?.NumberOfItems !== "" && data?.NumberOfItems > 0)?.map((d) => {
          return {
            Id: d?.Product?.Id,
            Name: d?.Product?.Name,
            NumberOfItems: d?.NumberOfItems,
            Price: d?.Product?.Price,
            DiscountPercentage: d?.DiscountPercentage,
            DeliveryHour: d?.DeliveryHour,
            DeliveryMinute: d?.DeliveryMinute
          }
        })
        : orderDetails?.ProductOtherOrders?.map((d) => {
          return {
            Id: d?.Id,
            Name: d?.Name,
            NumberOfItems: d?.NumberOfItems,
            Price: d?.Price,
            DiscountPercentage: d?.DiscountPercentage,
            DeliveryHour: d?.DeliveryHour,
            DeliveryMinute: d?.DeliveryMinute
          }
        }),
      "Comment": (() => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = editOrderProductStatus ? updatedSharedComment : orderDetails?.Comment || "";
        return tempDiv.textContent || tempDiv.innerText || "";
      })(),
      "CommentHtml": editOrderProductStatus ? updatedSharedComment : orderDetails?.CommentHtml,
      "InternalComment": (() => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = editOrderProductStatus ? updatedInternalComment : orderDetails?.InternalComment || "";
        return tempDiv.textContent || tempDiv.innerText || "";
      })(),
      "InternalCommentHtml": editOrderProductStatus ? updatedInternalComment : orderDetails?.InternalCommentHtml,
      "DeliveryMethod": selectedDeliveryMethod,
      "OrderStatusId": orderDetails?.OrderStatus?.Id,
      "OrderedByName": updatedOrderByName,
      "OrderedByEmail": updatedOrderByEmail,
      "DeliveryDate": orderDetails?.DeliveryDate,
      "DeliveryHour": moment(pickupTime, "HH:mm").format("HH"),
      "DeliveryMinute": moment(pickupTime, "HH:mm").format("mm"),
      "LocationId": orderDetails?.Location?.Id,
      "Title": updatedTitle,
      "FieldValues": fieldValues?.map((field) => ({
        "FieldId": field?.FieldId ?? 0,
        "Value": field?.Value ?? ""
      }))
    }

    const checkValidProductPickupTime = (data) => {
      return !data?.every((d) => {
        const deliveryTime = moment({
          hour: Number(d?.DeliveryHour),
          minute: Number(d?.DeliveryMinute)
        });

        const openTime = moment(timeWhenOpen, "HH:mm");

        const isValid = d?.DeliveryHour ? deliveryTime.isSameOrAfter(openTime) : true;

        return isValid; // all items must pass this
      });
    };

    const checkValidOtherProductPickupTime = (data) => {
      return !data?.every((d) => {
        const deliveryTime = moment({
          hour: Number(d?.DeliveryHour),
          minute: Number(d?.DeliveryMinute)
        });

        const openTime = moment(timeWhenOpen, "HH:mm");

        const isValid = d?.DeliveryHour ? deliveryTime.isSameOrAfter(openTime) : true;

        return isValid; // all items must pass this
      });
    }

    if (data?.Products?.length + data?.ProductsOther?.length <= 0 || data?.Products?.some((p) => p?.NumberOfItems && p?.NumberOfItems === 0) || data?.ProductsOther?.some((p) => p?.NumberOfItems && p?.NumberOfItems === 0)) {
      toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnMusthaveOneProduct, "Must have one product!"))
    } else if (!data?.Title) {
      toast.error(getDynamicLabel(orderDetailsTranslation?.msgWrnTitleRequire, "Title is Required"))
    } else if (!selectedDepartment?.Id || selectedDepartment?.ChildDepartments?.length > 0) {
      toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnCostCenterRequired, "Costcenter is required!"))
    } else if (!data?.OrderedByName && !data?.OrderedByEmail) {
      toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnOrderByRequired, "Order By is required!"))
      // } else if (checkValidProductPickupTime(data?.Products) || checkValidOtherProductPickupTime(data?.ProductsOther)) {
      //   toast.error("Enter valid pickup time!")
    } else {
      setIsSaveCanteenLoading(true)
      await cateringOrderWithoutMeeting(orderDetails?.Id, data).then((response) => {
        if (!response) {
          toast.success(getDynamicLabel(orderDetailsTranslation?.msgSuccessOrderUpdated, "Order Updated Successfully."))
          getDetails(orderId)
          GetCateringFields(orderId)
          setEditCanteenUsersStatus(false)
          setEditOrderProductStatus(false)
        } else {
          handleError(response)
        }
      }).catch((error) => {
        handleError(error)
      }).finally(() => {
        setIsSaveCanteenLoading(false)
      })
    }
  }

  const UpdateOrderedByAndDeliveredBy = async () => {
    if (orderDetails?.Id) {
      const requestPayload = {
        "Responsible": deliveryOrderUsers,
        "OrderedByName": updatedOrderByName,
        "OrderedByEmail": updatedOrderByEmail,
      }

      setIsSaveCanteenLoading(true)
      await updateCateringOrderMetadata(orderDetails?.Id, requestPayload).then((response) => {
        if (!response) {
          toast.success(getDynamicLabel(orderDetailsTranslation?.msgSuccessOrderUpdated, "Order Updated Successfully."))
        } else {
          toast.error(response?.Message)
        }
      }).catch((error) => {
        handleError(error)
      }).finally(() => {
        getDetails(orderId)
        GetCateringFields(orderId)
        setEditCanteenUsersStatus(false)
        setEditOrderProductStatus(false)
        setIsSaveCanteenLoading(false)
      })
    }
    return
  }

  const SaveCanteenOrder = () => {
    // const validationForTime = updatedProductList?.map((p, i) => {
    //   const time = p?.DeliveryMinute ? p?.DeliveryHour + ":" + p?.DeliveryMinute : p?.DeliveryHour
    //   return {
    //     ...p,
    //     isValid: time ? (
    //       moment(moment(time, "HH:mm")._d).isSame(moment(moment(orderDetails?.Meeting?.Start).format("HH:mm"), "HH:mm")._d) ||
    //       moment(moment(time, "HH:mm")._d).isSame(moment(moment(orderDetails?.Meeting?.End).format("HH:mm"), "HH:mm")._d) ||
    //       moment(moment(time, "HH:mm")._d).isBetween(moment(moment(orderDetails?.Meeting?.Start).format("HH:mm"), "HH:mm")._d, moment(moment(orderDetails?.Meeting?.End).format("HH:mm"), "HH:mm")._d)
    //     ) : true
    //   }
    // })

    const validationForTime = updatedProductList?.map((p) => {
      const time = p?.DeliveryMinute ? `${p?.DeliveryHour}:${p?.DeliveryMinute}` : p?.DeliveryHour
      const parsedTime = moment(`${moment(orderDetails?.Meeting?.Start).format("YYYY-MM-DD")}T${time}:00`)
      const startTime = moment(orderDetails?.Meeting?.Start)
      const endTime = moment(orderDetails?.Meeting?.End)

      return {
        ...p,
        isValid: time ? parsedTime.isBetween(startTime, endTime, null, "[]") : true,
      };
    });

    // const inValidOrders = validationForTime?.map((d, i) => ({ ...d, Index: i }))?.filter((order) => !order?.isValid)
    let inValidOrders = []
    if (selectedDeliveryMethod === "Delivery") {
      inValidOrders = validationForTime?.map((d, i) => ({ ...d, Index: i }))?.filter((order) => !order?.isValid)
    } else {
      inValidOrders = []
    }

    if (inValidOrders?.length === 0) {
      const requestPayload = {
        "Catering": {
          "DepartmentId": editOrderProductStatus ? selectedDepartment?.Id : orderDetails?.Department?.Id,
          "InvoiceInternal": invoiceInternal,
          "InvoiceExternalDetails": invoiceInternal === false ? invoiceExternalDetails : null,
          "Responsible": deliveryOrderUsers,
          "NumberOfPeople": editOrderProductStatus
            ? updatedInternalAttendees
            : orderDetails?.NumberOfPeople,
          "ExternalAttendeesPeoples": editOrderProductStatus
            ? updatedExternalAttendees
            : orderDetails?.ExternalAttendeesPeoples,
          "Products": editOrderProductStatus ? (
            updatedProductList?.filter((data) =>
              (cateringAllProduct ?? [])?.filter((d) => d?.Id === data?.Product?.Id).length !== 0 &&
              data?.NumberOfItems > 0
            )?.map((d) => ({
              ProductId: d?.Product.Id,
              NumberOfItems: d?.NumberOfItems,
              DiscountPercentage: d?.DiscountPercentage,
              DeliveryHour: d?.DeliveryHour,
              DeliveryMinute: d?.DeliveryMinute
              // DeliveryHour: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryHour,
              // DeliveryMinute: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryMinute
            }))
          ) : (
            orderDetails?.ProductOrders?.map((d) => ({
              ProductId: d?.Product?.Id,
              NumberOfItems: d?.NumberOfItems ?? 0,
              DiscountPercentage: d?.DiscountPercentage,
              DeliveryHour: d?.DeliveryHour,
              DeliveryMinute: d?.DeliveryMinute
              // DeliveryHour: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryHour,
              // DeliveryMinute: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryMinute
            }))
          ),
          "ProductsOther": editOrderProductStatus ? (
            updatedProductList?.filter((data) =>
              data?.Product?.Name?.trim() !== "" &&
              (cateringAllProduct ?? [])?.filter((d) => d?.Id === data?.Product?.Id).length === 0 &&
              data?.NumberOfItems !== ""
              && data?.NumberOfItems > 0
            )?.map((d) => ({
              Id: d?.Product?.Id,
              Name: d?.Product?.Name,
              NumberOfItems: d?.NumberOfItems,
              Price: d?.Product?.Price,
              DiscountPercentage: d?.DiscountPercentage,
              DeliveryHour: d?.DeliveryHour,
              DeliveryMinute: d?.DeliveryMinute
              // DeliveryHour: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryHour,
              // DeliveryMinute: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryMinute
            }))
          ) : (
            orderDetails?.ProductOtherOrders?.map((d) => ({
              Id: d?.Product?.Id,
              Name: d?.Product?.Name,
              NumberOfItems: d?.NumberOfItems,
              Price: d?.Product?.Price,
              DiscountPercentage: d?.DiscountPercentage,
              DeliveryHour: d?.DeliveryHour,
              DeliveryMinute: d?.DeliveryMinute
              // DeliveryHour: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryHour,
              // DeliveryMinute: selectedDeliveryMethod === "Pickup" ? "" : d?.DeliveryMinute
            }))
          ),
          "Comment": (() => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = editOrderProductStatus ? updatedSharedComment : orderDetails?.Comment || "";
            return tempDiv.textContent || tempDiv.innerText || "";
          })(),
          "CommentHtml": editOrderProductStatus ? updatedSharedComment : orderDetails?.CommentHtml,
          "InternalComment": (() => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = editOrderProductStatus ? updatedInternalComment : orderDetails?.InternalComment || "";
            return tempDiv.textContent || tempDiv.innerText || "";
          })(),
          "InternalCommentHtml": editOrderProductStatus ? updatedInternalComment : orderDetails?.InternalCommentHtml,
          "DeliveryMethod": selectedDeliveryMethod,
          "OrderStatusId": orderDetails?.OrderStatus?.Id,
          "OrderedByName": updatedOrderByName,
          "OrderedByEmail": updatedOrderByEmail,
          "FieldValues": fieldValues?.map((field) => ({
            "FieldId": field?.FieldId ?? 0,
            "Value": field?.Value ?? ""
          }))
        },
        "MyDeskMeetingId": orderDetails?.Meeting?.Id,
        "MeetingroomId": orderDetails?.Meeting?.MeetingRooms[0]?.Id,
        "ExchangeMeetingId": orderDetails?.Meeting?.ExchangeId,
        "ExchangeICalUId": orderDetails?.Meeting?.ExchangeICalUId,
      }

      if (
        (invoiceInternal ?
          selectedDepartment?.Id && !selectedDepartment?.ChildDepartments?.length
          : (
            requestPayload?.Catering?.InvoiceExternalDetails?.CompanyName?.trim()
              ? ((
                requestPayload?.Catering?.InvoiceExternalDetails?.CVR ?
                  (requestPayload?.Catering?.InvoiceExternalDetails?.CVR?.length === 13 || requestPayload?.Catering?.InvoiceExternalDetails?.CVR?.length === 8) :
                  true
              ) && (
                  requestPayload?.Catering?.InvoiceExternalDetails?.Mail ?
                    emailRegex.test(requestPayload?.Catering?.InvoiceExternalDetails?.Mail) :
                    true
                ))
              : false
          )
        ) &&
        (!editCanteenUsersStatus
          ? (requestPayload?.Catering?.Products?.length > 0 || requestPayload?.Catering?.ProductsOther?.length > 0)
          : true
        ) &&
        (requestPayload?.Catering?.NumberOfPeople + requestPayload?.Catering?.ExternalAttendeesPeoples > 0 && requestPayload?.Catering?.OrderedByName !== "" && requestPayload?.Catering?.OrderedByEmail !== "")
      ) {
        setIsSaveCanteenLoading(true)
        createUpdateOrder(requestPayload, orderDetails?.Meeting?.Id).then((response) => {
          if (!response) {
            toast.success(getDynamicLabel(orderDetailsTranslation?.msgSuccessOrderUpdated, "Order Updated Successfully."))
          } else {
            toast.error(response?.Message)
          }
        }).catch((error) => {
          handleError(error)
        }).finally(() => {
          getDetails(orderId)
          GetCateringFields(orderId)
          setEditCanteenUsersStatus(false)
          setEditOrderProductStatus(false)
          setIsSaveCanteenLoading(false)
        })
      } else {
        if (!editCanteenUsersStatus ? (requestPayload?.Catering?.Products?.length === 0 && requestPayload?.Catering?.ProductsOther?.length === 0) : false) {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnMusthaveOneProduct, "Must have one product!"))
        } else if (invoiceInternal && (!selectedDepartment?.Id || selectedDepartment?.ChildDepartments?.length > 0)) {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnCostCenterRequired, "Costcenter is required!"))
        } else if (!invoiceInternal && requestPayload?.Catering?.InvoiceExternalDetails?.CVR && requestPayload?.Catering?.InvoiceExternalDetails?.CVR?.length !== 8 && requestPayload?.Catering?.InvoiceExternalDetails?.CVR?.length !== 13) {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnEnterCVREANNumberValid, "Please Enter CVR/EAN number must be 8/13 digit long!"))
        } else if (!invoiceInternal && requestPayload?.Catering?.InvoiceExternalDetails?.Mail && !emailRegex.test(requestPayload?.Catering?.InvoiceExternalDetails?.Mail)) {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnValidMail, "Input valid mail!"))
        } else if (!invoiceInternal && !requestPayload?.Catering?.InvoiceExternalDetails?.CompanyName?.trim()) {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnExternalInvoiceCompanyNameRequired, "External invoice company name required!"))
        } else if (requestPayload?.Catering?.NumberOfPeople + requestPayload?.Catering?.ExternalAttendeesPeoples <= 0) {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnAttendeesRequired, "Attendees is required!"))
        } else if (requestPayload?.Catering?.OrderedByName === "" && requestPayload?.Catering?.OrderedByEmail === "") {
          toast.error(getDynamicLabel(orderDetailsTranslation?.msgWarnOrderByRequired, "Order By is required!"))
        }
      }
    } else {
      setError({ Status: true, Indexs: inValidOrders?.map((order) => order?.Index) })
      scrollToDiv()
      toast?.error(`${getDynamicLabel(orderDetailsTranslation?.msgWarnEnterValidTime, "Please enter valid time between")} ${moment(orderDetails?.Meeting?.Start).format("HH:mm")} - ${moment(orderDetails?.Meeting?.End).format("HH:mm")} !`)
    }
  }

  const GetCateringOrderStatus = async () => {
    setIsLoading(true)

    if (AllCateringOrderStatus?.length === 0) {
      await getCateringOrderStatus().then((response) => {
        dispatch(changeAllCateringOrderStatusValue(response))
      }).catch((error) => {
        dispatch(changeAllCateringOrderStatusValue([]))
        handleError(error)
        setIsLoading(false)
      })
    }
  }

  const GetCateringFields = async () => {
    setIsLoading(true)
    getCateringField(orderId).then((response) => {
      if (typeof response === "object" && response?.length > 0) {
        setAllCateringFields(response)
        setFieldValues(response?.map(field => ({
          FieldId: field?.Id,
          Value: field?.DefaultValue || ""
        })))
      } else {
        handleError(response)
        setAllCateringFields([])
        setFieldValues([])
      }
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setIsLoading(false)
    })
  }

  const CancelCatering = async () => {
    if (orderDetails?.Id) {
      const response = await cancelCatering(orderDetails?.Id)
      if (!response) {
        toast.success(getDynamicLabel(orderDetailsTranslation?.msgSuccessOrderCancelled, "Order cancelled successfully."))
        navigate("/")
      } else {
        await getDetails(orderId)
        handleError(response)
      }
    }
    return
  }

  const handleSelect = (level, selectedOption) => {
    const newPath = [...selectedPath.slice(0, level), selectedOption]
    setSelectedPath(newPath)

    const finalDept = getDepartmentByPath(newPath.map(opt => opt.value))
    setSelectedDepartment(finalDept)
  }

  const getDepartmentByPath = (pathIds, currentList = allDepartments) => {
    let current = null;
    for (let id of pathIds) {
      current = currentList.find((d) => d.Id === id)

      if (current?.ChildDepartments?.length) {
        currentList = current.ChildDepartments;
      } else {
        break
      }
    }

    return current
  };

  const renderDropdowns = () => {
    const dropdowns = []
    let currentList = allDepartments

    for (let i = 0; ; i++) {
      const selectedOption = selectedPath[i] || null

      const options = currentList.map((dept) => ({
        label: dept.Name,
        value: dept.Id,
      }))

      dropdowns?.push(
        <div key={i} style={{ marginBottom: "10px" }}>
          <Select
            value={selectedOption}
            onChange={(option) => handleSelect(i, option)}
            options={options}
            placeholder={getDynamicLabel(orderDetailsTranslation?.lblSelectCostCenter, "Select Costcenter")}
            className="form-select p-0"
            styles={{
              control: (baseStyles) => ({
                ...baseStyles,
                border: "none",
                boxShadow: "none",
                padding: "8px 10px",
                borderRadius: 8,
              }),
            }}
            components={{
              IndicatorSeparator: () => null,
              DropdownIndicator: () => null
            }}
          />

          <span className="txt-sm txt-gray px-1">
            {currentList?.find((d) => d?.Id === selectedOption?.value)?.ManagerName}
          </span>
        </div>
      )

      const selectedDept = currentList.find((d) => d.Id === selectedOption?.value)

      if (selectedDept?.ChildDepartments?.length > 0) {
        currentList = selectedDept.ChildDepartments
      } else {
        break;
      }
    }

    return dropdowns
  }

  const findPathToDepartment = (targetId, nodes = allDepartments, path = []) => {
    for (const node of nodes) {
      const newPath = [...path, node]

      if (node.Id === targetId) return newPath

      if (node.ChildDepartments.length > 0) {
        const result = findPathToDepartment(targetId, node.ChildDepartments, newPath);
        if (result) return result;
      }
    }
    return null
  }

  useEffect(() => {
    if (orderDetails?.Department?.Id) {
      const fullDeptPath = findPathToDepartment(orderDetails?.Department?.Id)

      if (fullDeptPath) {
        const formattedPath = fullDeptPath.map((dept) => ({
          label: dept.Name,
          value: dept.Id,
        }))
        setSelectedPath(formattedPath)

        const finalDept = getDepartmentByPath(formattedPath.map(d => d.Id))
        setSelectedDepartment(finalDept)
      }
    }
  }, [orderDetails?.Department?.Id])

  // useEffect(() => {
  //   let subscribed = true

  //   if (orderDetails?.Location?.Id && userSearch?.length >= 3) {
  //     searchADColleague(orderDetails?.Location?.Id, userSearch).then((response) => {
  //       if (subscribed) {
  //         setColleaguesList(response?.length >= 0 ? response : [])
  //       }
  //     }).catch((error) => {
  //       if (subscribed) {
  //         setColleaguesList([])
  //         handleError(error)
  //       }
  //     })
  //   } else {
  //     setColleaguesList([])
  //   }

  //   return () => {
  //     subscribed = false
  //   }
  // }, [orderDetails?.Location?.Id, userSearch])

  useEffect(() => {
    let subscribed = true

    const timeout = setTimeout(async () => {
      if (orderDetails?.Location?.Id && userSearch?.length >= 3) {
        setIsUserSearchLoading(true)
        await searchADColleague(orderDetails?.Location?.Id, userSearch).then((response) => {
          if (subscribed) {
            if (typeof response === "object") {
              setColleaguesList(response)
            } else {
              setColleaguesList((prev) => prev?.length > 0 ? [] : prev)
              handleError(response)
            }
          }
        }).catch((error) => {
          if (subscribed) {
            setColleaguesList((prev) => prev?.length > 0 ? [] : prev)
            handleError(error)
          }
        }).finally(() => {
          setIsUserSearchLoading(false)
        })
      } else {
        if (subscribed) {
          setColleaguesList((prev) => prev?.length > 0 ? [] : prev)
        }
      }
    })

    return () => {
      clearTimeout(timeout)
      subscribed = false
    }
  }, [orderDetails?.Location?.Id, userSearch])

  // Get Order Details
  useEffect(() => {
    getDetails(orderId)
  }, [orderId])

  // GET CATERING FIELD
  useEffect(() => {
    GetCateringFields(orderId)
  }, [orderId])

  useEffect(() => {
    GetCateringOrderStatus()
    if (dispatch) {
      getAdminLocation().then((response) => {
        dispatch(changeAllLocationValue(response))
      }).catch((error) => {
        dispatch(changeAllLocationValue([]))
        handleError(error)
      })

      getDepartment().then((response) => {
        dispatch(changeAllDepartmentValue(response))
      }).catch((error) => {
        dispatch(changeAllDepartmentValue([]))
        handleError(error)
      })
    }
  }, [dispatch])

  useEffect(() => {
    if (invoiceInternal === true) {
      setInvoiceExternalDetails({
        CompanyName: "",
        Address: "",
        Zip: "",
        CVR: "",
        Att: "",
        Mail: ""
      })
    }
  }, [invoiceInternal])

  // Company Query Search
  useEffect(() => {
    let subscribed = true

    const timeout = setTimeout(() => {

      if (companyQueryString?.trim()) {
        getAllCompanyNameQuery(companyQueryString).then((response) => {
          if (subscribed) {
            response?.length > 0 && setAllCompanyResponse(response)
          }
        }).catch((error) => {
          if (subscribed) {
            handleError(error)
          }
        }).finally(() => {
          if (subscribed) {
          }
        })
      }
    }, 1000);

    return () => {
      subscribed = false
      clearTimeout(timeout)
    }
  }, [companyQueryString])

  useEffect(() => {
    setIsLoading(true)
    getCanteenUser().then((response) => {
      if (response && typeof response === "object" && response?.Data?.length > 0) {
        setAllCanteenUsers(response?.Data)
      } else {
        setAllCanteenUsers([])
        handleError(response)
      }
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setIsLoading(false)
    })
  }, [])

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        resetSearchInput(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchInputCardStatus])

  useEffect(() => {
    setIsLoading(true)
    getTranslationWithPageName(PAGE_NAME?.ORDER_DETAILS, appName).then((response) => {
      if (typeof response === "object" && response?.length >= 0) {
        dispatch(changeOrderDetailsTranslationValue(convertRespArrToLabelObject(response)))
      } else {
        handleError(response)
      }
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setIsLoading(false)
    })
  }, [dispatch])

  return (
    <>
      {(isLoading || isSaveCanteenLoading) && <Loader />}

      <button onClick={() => window.history.back()} className="navigation-back-arrow">
        <i className="fa fa-arrow-left" />
      </button>

      {typeof orderDetails === "object" && Object.keys(orderDetails)?.length > 0 && (
        <>
          <section className="section">
            <div className="row my-4">
              <div className="col-9">
                <div className="pagetitle">
                  <h1 className="mt-2">
                    {orderDetails?.Meeting?.Id ? (
                      orderDetails?.Meeting?.Title
                    ) : orderDetails?.Title ? (
                      `${orderDetails?.Title} (${getDynamicLabel(orderDetailsTranslation?.lblAPickupOrder, "A Pickup Order")})`
                    ) : (
                      getDynamicLabel(orderDetailsTranslation?.lblAPickupOrder, "A Pickup Order")
                    )}
                  </h1>
                </div>
              </div>

              {/* First Top Right Edit Button */}
              <div className="col-3 text-end">
                <button
                  onClick={() => {
                    setEditCanteenUsersStatus(!editCanteenUsersStatus)
                    setEditOrderProductStatus(false)
                    !editCanteenUsersStatus && resetDeliveryGroupState()
                  }}
                  className="btn btn-secondary btn-icon  btn-icon-md"
                >
                  <img alt="icon-close" src={editCanteenUsersStatus ? iconClose : iconEdit} />
                </button>
              </div>
            </div>

            <div className="card-content mb-4">
              <div className="row list mt-3 ">
                {/* Location */}
                <div className="col-6 txt-md mb-4 d-flex">
                  <div className="icon-md icon-md-bg d-inline-block">
                    <img alt="icon-pin" src={iconPin} />
                  </div>
                  <div className="userInfo d-inline-block">
                    <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblLocation, "Location")}</span>
                    <div className="d-flex flex-wrap">
                      {orderDetails?.Meeting?.MeetingRooms?.length > 0 && orderDetails?.Meeting?.MeetingRooms[0]?.Location && orderDetails?.Meeting?.MeetingRooms[0]?.Location?.Id ? (
                        <span className="me-1">
                          {orderDetails?.Meeting?.MeetingRooms[0]?.Location?.Name ? orderDetails?.Meeting?.MeetingRooms[0]?.Location?.Name : "- -"}
                        </span>
                      ) : (
                        <span>
                          {orderDetails?.Location?.Id && orderDetails?.Location?.Name ? orderDetails?.Location?.Name : "- -"}
                        </span>
                      )}
                      {orderDetails?.Meeting?.MeetingRooms?.length > 0 && orderDetails?.Meeting?.MeetingRooms[0]?.Location && orderDetails?.Meeting?.MeetingRooms[0]?.Location?.Id ? (
                        <span>
                          ({orderDetails?.Meeting?.MeetingRooms[0]?.Name ? orderDetails?.Meeting?.MeetingRooms[0]?.Name : "- -"})
                        </span>
                      ) : (<></>)}
                    </div>
                  </div>
                </div>

                {/* Participants */}
                {orderDetails?.Meeting?.Id && (
                  <div className="col-6 txt-md mb-4">
                    <div className="icon-md icon-md-bg d-inline-block">
                      <img alt="icon-users" src={iconUsers} />
                    </div>
                    <div className="userInfo d-inline-block persons">
                      <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblParticipants, "Participants")}</span>
                      <span>{orderDetails?.NumberOfPeople + orderDetails?.ExternalAttendeesPeoples + " " + getDynamicLabel(orderDetailsTranslation?.lblPersons, "Persons")}</span>
                    </div>
                  </div>
                )}

                {/* Meeting Time */}
                <div className="col-6 txt-md mb-4 d-flex">
                  <div className="icon-md icon-md-bg d-inline-block">
                    <img alt="icon-clock" src={iconClock} />
                  </div>
                  <div className="userInfo d-inline-block">
                    <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblMeetingTime, "Meeting time")}</span>
                    <div className="d-flex flex-wrap">
                      <span className="me-1">
                        {moment(orderDetails?.Meeting?.Id ? orderDetails?.Meeting?.Start : orderDetails?.DeliveryDate).format("DD-MM-YYYY")}
                      </span>
                      <span>
                        {orderDetails?.Meeting?.Id
                          && " (" + moment(orderDetails?.Meeting?.Start).format("HH:mm") + " - " + moment(orderDetails?.Meeting?.End).format("HH:mm") + ") "
                        }
                        {/* {orderDetails?.Meeting?.Id
                          ? " (" + moment(orderDetails?.Meeting?.Start).format("HH:mm") + " - " + moment(orderDetails?.Meeting?.End).format("HH:mm") + ") "
                          : " (" + pickupTime + ") "
                        } */}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Ordered by Name */}
                <div className="col-6 txt-md mb-4 d-flex">
                  <div className="icon-md icon-md-bg d-inline-block">
                    <img alt="icon-user" src={iconUser} />
                  </div>
                  <div className="userInfo d-inline-block" style={{ flex: 1 }}>
                    {editCanteenUsersStatus ? (
                      <div
                        ref={containerRef}
                        onClick={() => {
                          resetSearchInput(!searchInputCardStatus)
                          searchInputCardStatus && orderBySearch.current.focus()
                        }}
                        className="form-control custom-search-group hover"
                      >
                        <span className="text-md fs-6 " onClick={() => resetSearchInput(!searchInputCardStatus)}>
                          {updatedOrderByName}
                        </span>
                        {searchInputCardStatus && (
                          <div className="search-wrapper">
                            <input
                              value={userSearch} ref={orderBySearch}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => setUserSearch(e.target.value)}
                              className="form-control search-input"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblSearch, "search")}
                            />

                            {userSearch?.length < 3 ? (
                              <div className="item-card">
                                <p className="txt-md text-danger mb-0">
                                  {getDynamicLabel(orderDetailsTranslation?.lblPleaseEnter, "Please enter")} {3 - userSearch?.length} {getDynamicLabel(orderDetailsTranslation?.lblMoreCharacters, "or more characters")}
                                </p>
                              </div>
                            ) : (
                              <React.Fragment>
                                {[{ Name: userSearch, UPN: userSearch }, ...(colleaguesList ?? [])]?.map((data, i) =>
                                  <div
                                    key={i} className="item-card item-card-hover"
                                    onClick={() => {
                                      setUpdatedOrderByName(data.Name)
                                      setUpdatedOrderByEmail(data.UPN)
                                      setUpdatedOrderByPhone(data.MobilePhone)
                                      resetSearchInput(false)
                                    }}
                                  >
                                    <span>
                                      <b className=" mb-0 ">{data?.Name}</b>
                                      <p className="txt-sm mb-0">{data?.UPN}</p>
                                    </span>
                                  </div>
                                )}
                                {isUserSearchLoading && (
                                  <div className="item-card item-card-hover">
                                    <div className="d-flex justify-content-center">
                                      <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblOrderedByName, "Ordered by Name")}</span>
                        <span className="ellipsis">{orderDetails?.OrderedByName ? orderDetails?.OrderedByName : ""}</span>
                      </>
                    )}
                  </div>
                </div>

                {/* Order Status */}
                <div className="col-6 txt-md mb-4">
                  <div className="icon-md icon-md-bg d-inline-block">
                    {orderDetails?.OrderStatus?.Icon ? (
                      <img src={orderDetails?.OrderStatus?.Icon} alt="icon-order-status" />
                    ) : (
                      <img
                        src={orderDetails?.OrderStatus?.Id === 1
                          ? iconNotStarted
                          : orderDetails?.OrderStatus?.Id === 2
                            ? iconInProgress
                            : iconCompleted
                        }
                        alt="icon-order-status"
                      />
                    )}
                    {/* <img
                      src={orderDetails?.OrderStatus?.Id === 1
                        ? iconNotStarted
                        : orderDetails?.OrderStatus?.Id === 2
                          ? iconInProgress
                          : iconCompleted
                      }
                      alt="icon-order-status"
                    /> */}
                  </div>

                  <div className="userInfo d-inline-block">
                    <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblOrderStatus, "Order Status")}</span>
                    <span className="ellipsis">{orderDetails?.OrderStatus?.Name}</span>
                  </div>
                </div>

                {/* Ordered by Email */}
                <div className="col-6 txt-md mb-4 d-flex">
                  <div className="icon-md icon-md-bg d-inline-block">
                    <img alt="icon-user" src={iconUser} />
                  </div>
                  <div className="userInfo d-inline-block overflow-hidden">
                    <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblOrderedByEmail, "Ordered by Email")}</span>
                    <span className="ellipsis">{editCanteenUsersStatus ? updatedOrderByEmail : orderDetails?.OrderedByEmail}</span>
                  </div>
                </div>

                {/* Delivered by */}
                {/* {orderDetails?.Meeting?.Id && ( */}
                <div className="col-6 txt-md d-flex">
                  <div className="icon-md icon-md-bg d-inline-block">
                    <img src={iconUsers} alt="Profile" />
                  </div>

                  {!editCanteenUsersStatus && (
                    <div className="userInfo d-inline-block" style={{ flex: 1 }}>
                      <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblDeliveredBy, "Delivered by")}</span>
                      <span>
                        {orderDetails?.CanteenUsers?.length > 0 ? (
                          orderDetails?.CanteenUsers?.map((deliver, i) =>
                            i !== 0 && i !== orderDetails?.CanteenUsers?.length ? `, ${deliver.Name}`
                              : deliver?.Name
                          )
                        ) : (
                          "- -"
                        )}
                      </span>
                    </div>
                  )}

                  {editCanteenUsersStatus && (
                    <div onClick={() => resetSearchInput(false)} className="userInfo d-inline-block" style={{ flex: 1 }}>
                      <Select
                        isMulti
                        defaultValue={orderDetails?.CanteenUsers?.map((d) => ({ value: d?.Id, label: d.Name }))}
                        options={allCanteenUsers?.map((d) => ({ value: d?.Id, label: d.Name }))}
                        className="form-control p-0" placeholder={getDynamicLabel(orderDetailsTranslation?.lblSelectPersons, "Select Persons")}
                        onChange={(e) => setDeliveryOrderUsers(e.map((d) => Number(d.value)))}
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            border: "none",
                            boxShadow: "none",
                            borderRadius: 8,
                          }),
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                          DropdownIndicator: () => null,
                          ClearIndicator: () => null,
                        }}
                      />
                    </div>
                  )}
                </div>
                {/* )} */}

                {/* OrderBy Phone */}
                <div className="col-6 txt-md mb-4 d-flex">
                  <div className="icon-md icon-md-bg d-inline-block" style={{ width: "36px" }}>
                    {/* <img alt="icon-user" src={iconUser} /> */}
                    <div style={{ border: "1px solid #e8ecef", borderRadius: "25px", padding: "5px 8px", backgroundColor: "white" }}>
                      <i className="bi bi-telephone" style={{ fontSize: "17px", color: "lightgray" }} />
                    </div>
                  </div>
                  <div className="userInfo d-inline-block overflow-hidden">
                    <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblOrderedByPhone, "Ordered by Phone")}</span>
                    <span className="ellipsis">{editCanteenUsersStatus ? updatedOrderByPhone : orderDetails?.OrderedByPhone ?? "- -"}</span>
                  </div>
                </div>

                <div className="col-6" />

                {/* Order Number */}
                <div className="col-6 txt-md mb-4">
                  <div className="icon-md icon-md-bg d-inline-block">
                    <img src={iconOrderNumber} style={{ padding: 6 }} alt="icon-order-number" />
                  </div>
                  <div className="userInfo d-inline-block">
                    <span className="txt-sm txt-gray">{getDynamicLabel(orderDetailsTranslation?.lblOrderNumber, "Order Number")}</span>
                    <span>{orderDetails?.OrderNumber}</span>
                  </div>
                </div>

                {/* Save */}
                {editCanteenUsersStatus && (
                  <div className="col-12 mt-3">
                    <button
                      onClick={() => UpdateOrderedByAndDeliveredBy()}
                      className="btn btn-primary mb-2 btn-lg btn-full btnOuterSave"
                    >
                      {getDynamicLabel(orderDetailsTranslation?.btnSave, "Save")}
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="card card-revert" style={{ marginBottom: !editOrderProductStatus && "0px" }} id="prod-list">
              <div className="row mb-3 mt-2">
                <div className="col-9">
                  <div className="pagetitle mt-2">
                    <h2>{getDynamicLabel(orderDetailsTranslation?.lblOrders, "Orders")}</h2>
                  </div>
                </div>
                <div className="col-3 text-end">
                  <button
                    onClick={() => {
                      setEditOrderProductStatus(!editOrderProductStatus)
                      setEditCanteenUsersStatus(false)
                      resetUpdatedItemGroupState(orderDetails)
                    }}
                    className="btn btn-secondary btn-icon btn-icon-md"
                  >
                    <img src={editOrderProductStatus ? iconClose : iconEdit} alt="icon-edit" />
                  </button>
                </div>
              </div>

              {/* ============================================================================================ */}
              {/* ==================================== Static Order Details ========+========================= */}
              {/* ============================================================================================ */}
              {!editOrderProductStatus && (
                <div className="table-responsive table-custom">
                  <table className="table table-hover valignM">
                    <tbody>
                      {[...orderDetails?.ProductOrders, ...orderDetails?.ProductOtherOrders]?.length > 0 ? (
                        [...orderDetails?.ProductOrders, ...orderDetails?.ProductOtherOrders]?.sort((a, b) =>
                          Number(`${a?.DeliveryHour}${a?.DeliveryMinute}`) - Number(`${b?.DeliveryHour}${b?.DeliveryMinute}`)
                        )?.map((order, i) =>
                          <tr key={i}>
                            <td className="position-relative">
                              <span className="txt500">{order?.Product?.Name}</span>
                              {order?.Product?.Notes && (
                                <>
                                  <i className="fa fa-info-circle position-absolute" style={{ right: "14px", top: "16px" }} data-tooltip-place="top" data-tooltip-id="my-tooltip" data-tooltip-content={order.Product?.Notes} />
                                  <Tooltip id="my-tooltip" />
                                </>
                              )}
                            </td>
                            <td className="text-center">
                              <span className="txt500">
                                {typeof order?.DeliveryHour === "string" && typeof order?.DeliveryMinute === "string"
                                  ? order?.DeliveryHour && order?.DeliveryMinute && moment(`${order?.DeliveryHour}:${order?.DeliveryMinute}`, "HH:mm").format("HH:mm")
                                  : ""
                                }
                              </span>
                            </td>
                            <td className="text-center">
                              <span className="txt500">{order?.NumberOfItems}</span>
                              &nbsp;
                              <span className="txt-gray">
                                X&nbsp;{order.Product?.Price}&nbsp;{meetingLocation?.Currency === "" ? "DKK" : meetingLocation?.Currency}
                              </span>
                            </td>
                            <td>
                              <span className="txt500">
                                {(order?.NumberOfItems * order.Product?.Price)?.toFixed(2)}&nbsp;{meetingLocation?.Currency === "" ? "DKK" : meetingLocation?.Currency}
                              </span>
                            </td>
                          </tr>
                        )
                      ) : (
                        <tr>
                          <td colSpan="4">
                            <span className="txt-gray d-block">{getDynamicLabel(orderDetailsTranslation?.lblNoOrders, "No Orders")}</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}

              {/* ====================================================================================== */}
              {/* ======================================= Edit Product ================================= */}
              {/* ====================================================================================== */}
              {editOrderProductStatus && (
                <div className="table-responsive table-custom edit">
                  <table className="table table-hover valignM ">
                    {updatedProductList?.length > 0 && (
                      <thead>
                        <tr className="text-center">
                          <th className="position-relative" style={{ borderBottomWidth: "0px" }}></th>
                          <th className="delivery-time-td" style={{ borderBottomWidth: "0px" }}></th>
                          <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(orderDetailsTranslation?.lblQty, "Qty.")}</th>
                          <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(orderDetailsTranslation?.lblPrice, "Price")}</th>
                          <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(orderDetailsTranslation?.lblDiscount, "Discount")} %</th>
                          <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(orderDetailsTranslation?.lblDiscountAmount, "Discount Amount")}</th>
                          <th style={{ borderBottomWidth: "0px" }}>{getDynamicLabel(orderDetailsTranslation?.lblProductLineTotal, "Product Line Total")}</th>
                        </tr>
                      </thead>
                    )}

                    <tbody>
                      {updatedProductList?.length > 0 ? (
                        updatedProductList?.map((data, i) =>
                          <tr key={i}>
                            {/* Product */}
                            <td className="position-relative">
                              <CreatableSelect
                                isClearable
                                placeholder={getDynamicLabel(orderDetailsTranslation?.lblSelectProduct, "Select Product")}
                                value={data?.Product?.Name && [{ value: data?.Product?.Id, label: data?.Product?.Name }]}
                                onChange={(e) => {
                                  if (e) {
                                    setUpdatedProductList((prev) => prev?.map((data, j) => ({
                                      ...data,
                                      Product: i !== j ? (
                                        data?.Product
                                      ) : (
                                        cateringAllProduct?.find((d) => d?.Id === e?.value)?.Id ? (
                                          cateringAllProduct?.find((d) => d?.Id === e?.value)
                                        ) : ({ Id: 0, Name: e?.value, Notes: e?.value, Price: 0 })
                                      ),
                                    })))
                                  }
                                }}
                                options={cateringAllProduct?.map((d) => ({ value: d?.Id, label: d?.Name }))}
                                styles={{
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    border: "none",
                                    boxShadow: "none",
                                    padding: "6px 8px",
                                    borderRadius: 8,
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0,
                                  }),
                                }}
                                components={{
                                  IndicatorSeparator: () => null,
                                  DropdownIndicator: () => null,
                                  ClearIndicator: () => null,
                                }}
                              />

                              {data?.Product?.Name && cateringAllProduct && cateringAllProduct?.filter((d) => d?.Id === data?.Product?.Id).length > 0 && (
                                <>
                                  <i
                                    className="fa fa-info-circle position-absolute tool-tip"
                                    data-tooltip-place="top" data-tooltip-id="my-tooltip"
                                    data-tooltip-content={cateringAllProduct?.find((d) => d?.Id === data?.Product?.Id)?.Notes}
                                  />
                                  <Tooltip id="my-tooltip" />
                                </>
                              )}
                            </td>

                            {/* Delivery Time */}
                            <td className="delivery-time-td">
                              <InputMask
                                mask="HH:mm"
                                onBlur={(e) => handleOnBlur(e.target.value, i)}
                                replacement={{ H: /\d/, m: /\d/ }}
                                value={(() => {
                                  const time = updatedProductList?.find((prod, index) => index === i)
                                  return time?.DeliveryMinute ? time?.DeliveryHour + ":" + time?.DeliveryMinute : time?.DeliveryHour
                                })()}
                                onChange={(e) => handleDeliveryTimeChange(e.target.value, i)}
                                separate
                                className="form-control text-center"
                                placeholder="HH:mm"
                                style={{ border: error?.Status && error?.Indexs?.some((prod) => prod === i) && "1px solid red" }}
                              />
                            </td>

                            {/* Qty */}
                            <td className="qty-td">
                              <input
                                type="number"
                                min={minCateringProductQty}
                                max={maxCateringProductQty}
                                className="form-control text-center"
                                placeholder={getDynamicLabel(orderDetailsTranslation?.lblQty, "Qty.")}
                                value={data?.NumberOfItems ?? 0}
                                onChange={(e) => {
                                  const value = e.target.value <= minCateringProductQty
                                    ? minCateringProductQty
                                    : e.target.value >= maxCateringProductQty
                                      ? maxCateringProductQty
                                      : Number(e.target.value)
                                  if (Number.isInteger(value) && value > -1) {
                                    setUpdatedProductList((prev) => prev?.map((data, j) => {
                                      if (i !== j) {
                                        return data
                                      } else {
                                        const newObj = ({
                                          ...data,
                                          NumberOfItems: value,
                                        })

                                        return ({
                                          ...newObj,
                                          DiscountAmount: getNewDiscountAmount(newObj)?.DiscountAmount,
                                          FinalPrice: getNewDiscountAmount(newObj)?.FinalPrice
                                        })
                                      }
                                    }))
                                  }
                                }}
                              />
                            </td>

                            {/* Price */}
                            <td className="price-td">
                              <input
                                type="text"
                                className="form-control text-center"
                                placeholder={getDynamicLabel(orderDetailsTranslation?.lblPrice, "Price")}
                                value={data?.Product?.Price}
                                onChange={(e) => {
                                  if (Number.isInteger(Number(e.target.value))) {
                                    setUpdatedProductList((prev) => prev?.map((data, j) => {
                                      if (i !== j) {
                                        return data
                                      } else {
                                        const newObj = ({
                                          ...data,
                                          Product: ({
                                            ...data?.Product,
                                            Price: Number(e.target.value)
                                          }),
                                        })

                                        return ({
                                          ...newObj,
                                          DiscountAmount: getNewDiscountAmount(newObj)?.DiscountAmount,
                                          FinalPrice: getNewDiscountAmount(newObj)?.FinalPrice
                                        })
                                      }
                                    }))
                                  }
                                }}
                                disabled={cateringAllProduct?.filter((d) => d?.Id === data?.Product?.Id)?.length > 0}
                              />
                            </td>

                            {/* Discount Percentage */}
                            <td className="d-flex align-items-center justify-content-center">
                              <span className="d-flex align-items-center justify-content-center flex-grow-1">
                                <input
                                  min={0} max={100}
                                  type="number"
                                  value={data?.DiscountPercentage}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const regex = /^\d{0,3}(\.\d{0,2})?$/;

                                    if (value === "" || (regex.test(value) && Number(value) >= 0 && Number(value) <= 100)) {
                                      setUpdatedProductList((prev) =>
                                        prev?.map((data, j) => {
                                          if (i !== j) return data;

                                          const newObj = {
                                            ...data,
                                            DiscountPercentage: value === "" ? "" : Number(value),
                                          };

                                          return {
                                            ...newObj,
                                            DiscountAmount: getNewDiscountAmount(newObj)?.DiscountAmount,
                                            FinalPrice: getNewDiscountAmount(newObj)?.FinalPrice,
                                          };
                                        })
                                      );
                                    }
                                  }}
                                  className="form-control text-center"
                                  placeholder={`${getDynamicLabel(orderDetailsTranslation?.lblDiscount, "Discount")} %`}
                                  style={{ borderRight: 0 }}
                                />
                                <span
                                  className="input-group-text flex-grow-1"
                                  style={{ backgroundColor: "white", padding: "16px 12px", outline: "none", border: "none" }}
                                >
                                  <i className="fa-solid fa-percent" />
                                </span>
                              </span>
                            </td>

                            {/* Discount Amount */}
                            <td>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control text-center"
                                placeholder={getDynamicLabel(orderDetailsTranslation?.lblDiscountAmount, "Discount Amount")}
                                value={data?.DiscountAmount ? (
                                  `${data?.DiscountAmount} ${meetingLocation?.Currency ? meetingLocation?.Currency : "DKK"}`
                                ) : ""}
                              />
                            </td>

                            {/* Final Total */}
                            <td>
                              <input
                                type="text"
                                disabled={true}
                                className="form-control text-center"
                                placeholder={getDynamicLabel(orderDetailsTranslation?.lblProductLineTotal, "Product Line Total")}
                                value={data?.FinalPrice ? (
                                  `${data?.FinalPrice} ${meetingLocation?.Currency ? meetingLocation?.Currency : "DKK"}`
                                ) : ""}
                              />
                            </td>

                            {/* Delete Btn */}
                            <td className="dlt-td">
                              <button
                                type="button"
                                className="btn btn-secondary btn-icon"
                                onClick={() => handleDeleteOrder(data, i)}
                              >
                                <img alt="icon-trash" src={iconTrash} />
                              </button>
                            </td>
                          </tr>
                        )
                      ) : (
                        <tr>
                          <td colSpan="4">
                            <span className="txt-gray d-block no-order" id="Noorders">
                              {getDynamicLabel(orderDetailsTranslation?.lblNoOrders, "No Orders")}
                            </span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {/*================= Discount Amount =================*/}
                  {inputAmount > 0 && (
                    <div className="discount d-flex justify-content-end">
                      <div className="col-10 p-3 d-flex justify-content-end align-items-center">
                        <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblDiscount, "Discount")}</span>
                      </div>

                      {/* Discount Amount */}
                      <div className="col-2 d-flex justify-content-end align-items-center">
                        <div className="input-group">
                          <input
                            type="number"
                            value={inputAmount}
                            disabled={inputAmount > 0}
                            className="discount-amount form-control form-control-sm text-center"
                            placeholder={getDynamicLabel(orderDetailsTranslation?.lblAmount, "Amount")}
                            style={{ borderRight: "none", boxShadow: "none" }}
                          />
                          <span className="input-group-text" style={{ backgroundColor: "white", border: "1px solid #e8ecef" }}>
                            {meetingLocation?.Currency === "" ? "DKK" : meetingLocation?.Currency}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/*================= Total Amount =================*/}
                  <div className="d-flex justify-content-end">
                    <div className="col-10 p-3 d-flex justify-content-end align-items-center">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblTotal, "Total")}</span>
                    </div>

                    <div className="col-2 d-flex justify-content-center align-items-center">
                      <span className="txt500">
                        {inputAmount > 0 ? (updatedPrice() - inputAmount).toFixed(2) : updatedPrice()}&nbsp;
                        {meetingLocation?.Currency === "" ? "DKK" : meetingLocation?.Currency}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* ============================================================================================ */}
              {/* ================================ Total Price And Add Item Button =========================== */}
              {/* ============================================================================================ */}
              <div className="row mb-2 mt-2">
                <div className="col-9">
                  {!editOrderProductStatus && (
                    <div className="pagetitle mt-2">
                      <h2 className="txt-black txtR">
                        {getDynamicLabel(orderDetailsTranslation?.lblTotal, "Total")} <span>{editOrderProductStatus ? updatedPrice()?.toFixed(2) : (orderDetails?.TotalPrice)?.toFixed(2)}</span>&nbsp;{meetingLocation?.Currency ?? "DKK"}
                      </h2>
                    </div>
                  )}
                </div>

                {editOrderProductStatus && (
                  <div className="col-3 text-end">
                    <button
                      id="addRow"
                      className="btn btn-secondary btn-icon btn-icon-md"
                      onClick={() => addRow()}
                    >
                      <img alt="icon-add" src={iconAdd} />
                    </button>
                  </div>
                )}
              </div>

              {/* ============================================================================================ */}
              {/* ===================================== Display Order Details ================================ */}
              {/* ============================================================================================ */}
              {!editOrderProductStatus && (
                <div className="card-content">
                  { }
                  <div className="row list mt-3">
                    <div className="col-3 txt-md mt-3">
                      <span className="txt500">
                        {orderDetails?.Meeting !== null && orderDetails?.Meeting?.Id ? (
                          getDynamicLabel(orderDetailsTranslation?.lblCostCenterExternalCustomer, "Costcenter/External customer")
                        ) : (
                          getDynamicLabel(orderDetailsTranslation?.lblCostCenter, "Costcenter")
                        )}
                      </span>
                    </div>

                    <div className="col-9 txt-md mt-2">
                      {orderDetails?.InvoiceInternal === true ? (
                        <div className="userInfo d-inline-block departmentName mt-3">
                          <span>
                            {orderDetails?.Department?.Name}
                            {" ("}{orderDetails?.Department?.ManagerName}{")"}
                          </span>
                        </div>
                      ) : (
                        <div className="col-12 border p-2 rounded" style={{ width: "fit-content" }}>
                          {/* <div className="p-2"> */}
                          <label className="">
                            {getDynamicLabel(orderDetailsTranslation?.lblCompanyName, "CompanyName")} : &nbsp;
                            {orderDetails?.InvoiceExternalDetails?.CompanyName}
                          </label>

                          {orderDetails?.InvoiceExternalDetails?.Address && (
                            <label className="ms-3">
                              {getDynamicLabel(orderDetailsTranslation?.lblAddress, "Address")} : &nbsp;
                              {orderDetails?.InvoiceExternalDetails?.Address}
                            </label>
                          )}

                          {orderDetails?.InvoiceExternalDetails?.Zip && (
                            <label className="ms-3">
                              {getDynamicLabel(orderDetailsTranslation?.lblZip, "Zip")} : &nbsp;
                              {orderDetails?.InvoiceExternalDetails?.Zip}
                            </label>
                          )}

                          {orderDetails?.InvoiceExternalDetails?.CVR && (
                            <label className="ms-3">
                              {getDynamicLabel(orderDetailsTranslation?.lblCvrEan, "CVR/EAN")} : &nbsp;
                              {orderDetails?.InvoiceExternalDetails?.CVR}
                            </label>
                          )}

                          {orderDetails?.InvoiceExternalDetails?.Att && (
                            <label className="ms-3">
                              {getDynamicLabel(orderDetailsTranslation?.lblAtt, "Att")} : &nbsp;
                              {orderDetails?.InvoiceExternalDetails?.Att}
                            </label>
                          )}

                          {orderDetails?.InvoiceExternalDetails?.Mail && (
                            <label className="ms-3">
                              {getDynamicLabel(orderDetailsTranslation?.lblMail, "Mail")} : &nbsp;
                              {orderDetails?.InvoiceExternalDetails?.Mail}
                            </label>
                          )}

                          {/* </div> */}
                        </div>
                      )}
                    </div>
                  </div>

                  {allCateringFields?.length > 0 && allCateringFields?.map((field, fieldIndex) => (
                    <div key={fieldIndex} className="row list mt-3">
                      <div className="col-3 txt-md mt-3">
                        <span className="txt500">
                          {field?.Title ?? ""}
                        </span>
                      </div>

                      <div className="col-9 txt-md mb-2">
                        <div className="userInfo d-inline-block mt-3">
                          <span>{field?.DefaultValue ?? "--"}</span>
                        </div>
                      </div>
                    </div>
                  ))}

                  <div className="row list mt-3">
                    <div className="col-3 txt-md mt-3">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblDeliveryMethod, "Delivery Method")}</span>
                    </div>

                    <div className="col-9 txt-md mb-2">
                      <div className="userInfo d-inline-block mt-3">
                        <span>{orderDetails?.DeliveryMethod}</span>
                      </div>
                    </div>
                  </div>

                  {typeof orderDetails?.Meeting?.Id === "number" && (
                    <div className="row list mt-3 ">
                      <div className="col-3 txt-md mb-2 mt-2">
                        <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblInternal, "Internal")}</span>
                      </div>
                      <div className="col-3 txt-md mb-2 mt-2">
                        <span className="px-2">{orderDetails?.NumberOfPeople ?? 0}</span>
                      </div>
                      <div className="col-3 txt-md mb-2 mt-2">
                        <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblExternal, "External")}</span>
                      </div>
                      <div className="col-3 txt-md mb-2 mt-2">
                        <span>{orderDetails?.ExternalAttendeesPeoples ?? 0}</span>
                      </div>
                    </div>
                  )}

                  <div className="row list mt-3">
                    <div className="txt-md mb-2 mt-3">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblSharedComment, "Shared Comment")}</span>
                      <div className="txt-md mb-2 mt-3" dangerouslySetInnerHTML={{ __html: orderDetails?.CommentHtml ?? orderDetails?.Comment ?? "--" }} />
                    </div>

                    <div className="txt-md mb-2 mt-3">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblInternalComment, "Internal Comment")}</span>
                      <div className="txt-md mb-2 mt-3" dangerouslySetInnerHTML={{ __html: orderDetails?.InternalCommentHtml ?? orderDetails?.InternalComment ?? "--" }}>
                      </div>
                    </div>
                  </div>

                  {/* New Update Order Status And Delete Catering Order Buttons */}
                  <div className="d-flex align-items-center justify-content-end mt-3">
                    {/* New Update Order Status Button */}

                    {orderDetails?.OrderStatus?.Id === 12 ? (
                      <button
                        onClick={() => {
                          document.activeElement.blur()
                          // CancelOrder(orderDetails)
                        }}
                        className="btn btn-secondary btn-icon dashboard-order-status-icon-btn overflow-hidden d-flex align-items-center gap-1 me-2"
                      >
                        {orderDetails?.OrderStatus?.Icon && (
                          <img src={AllCateringOrderStatus.find((status) => status?.Id === 12)?.Icon} className="status-icon" alt={`icon-${AllCateringOrderStatus.find((status) => status?.Id === 12)?.Name}`} />
                        )}
                        <small className="order-status-text align-middle d-inline-flex">
                          {AllCateringOrderStatus?.find((status) => status?.Id === 12)?.Name ? AllCateringOrderStatus?.find((status) => status?.Id === 12)?.Name : "--"}
                        </small>
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            // To unfocus button after click
                            document.activeElement.blur()

                            const index = (AllCateringOrderStatus ?? [])?.findIndex((status) => status?.Id === orderDetails?.OrderStatus?.Id)
                            // const nextStatusId = (AllCateringOrderStatus ?? [])[index + 1]?.Id ?? (AllCateringOrderStatus ?? [])[0]?.Id // Old, Jump to start if end of array
                            const nextStatusId = (AllCateringOrderStatus ?? [])[index + 1]?.Id ?? 0 // New, Don't jump to start
                            if (nextStatusId === 12) {
                              CancelOrder(orderDetails)
                            } else {
                              UpdateCateringOrderStatus(nextStatusId)
                            }
                          }}
                          className="btn btn-secondary d-flex align-items-center gap-1 me-2"
                          style={{ height: 38 }}
                        >
                          {orderDetails?.OrderStatus?.Icon && (
                            <img src={orderDetails?.OrderStatus?.Icon} className="status-icon" alt={`icon-${orderDetails?.OrderStatus?.Name}`} />
                          )}
                          <small
                            className="order-status-text align-middle d-inline-flex"
                            style={{ color: "#444444", fontWeight: "600" }}
                          >
                            {orderDetails?.OrderStatus?.Name ? orderDetails?.OrderStatus?.Name : "--"}
                          </small>
                        </button>

                        <button
                          onClick={() => {
                            document.activeElement.blur()
                            CancelOrder(orderDetails)
                          }}
                          className="btn btn-secondary btn-icon dashboard-order-status-icon-btn overflow-hidden d-flex align-items-center gap-1 me-2"
                        >
                          {orderDetails?.OrderStatus?.Icon && (
                            <img src={AllCateringOrderStatus.find((status) => status?.Id === 12)?.Icon} className="status-icon" alt={`icon-${AllCateringOrderStatus.find((status) => status?.Id === 12)?.Name}`} />
                          )}
                          <small className="order-status-text align-middle d-inline-flex">
                            {AllCateringOrderStatus.find((status) => status?.Id === 12)?.Name ? AllCateringOrderStatus.find((status) => status?.Id === 12)?.Name : "--"}
                          </small>
                        </button>
                      </>
                    )}

                    {/* Delete Catering Order Button */}
                    <button
                      onClick={() => {
                        // To unfocus button after click
                        document.activeElement.blur()

                        confirmAlert({
                          title: getDynamicLabel(orderDetailsTranslation?.lblDeleteOrder, "Delete order"),
                          message: getDynamicLabel(orderDetailsTranslation?.lblWarnDeleteOrderConfirm, "Are you sure you want to delete this order?"),
                          buttons: [
                            {
                              label: getDynamicLabel(orderDetailsTranslation?.btnYes, "Yes"),
                              onClick: () => CancelCatering(),
                            },
                            {
                              label: getDynamicLabel(orderDetailsTranslation?.btnNo, "No"),
                              onClick: () => { },
                            },
                          ],
                        })
                      }}
                      className="btn btn-secondary btn-icon btn-icon-md"
                    >
                      <img alt="icon-trash" src={iconTrash} />
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* ============================================================================================ */}
            {/* ====================================== Edit Order Details  ================================= */}
            {/* ============================================================================================ */}
            {editOrderProductStatus && (
              <div className="card-content">
                {!(orderDetails?.Meeting && orderDetails?.Meeting?.Id) && (
                  <div className="row list mt-3">
                    <div className="col-3 d-flex align-items-center txt-md mt-3">
                      <span className="txt500">
                        {getDynamicLabel(orderDetailsTranslation?.lblTitle, "Title")}
                      </span>
                    </div>

                    <div className="col-9 txt-md mt-3">
                      <input
                        type="text"
                        value={updatedTitle}
                        onChange={(e) => setUpdatedTitle(e.target.value)}
                        className="rounded-2 form-control card-input m-0"
                        placeholder={getDynamicLabel(orderDetailsTranslation?.lblTitle, "Title")}
                      />
                    </div>
                  </div>
                )}

                {/* Costcenter */}
                <div className="row list mt-3 costcenter">
                  {orderDetails?.Meeting !== null && orderDetails?.Meeting?.Id ? (
                    <div className="col-sm-12 col-md-12 col-lg-3 col-xl-xl-3 txt-md mb-2">
                      <span className="txt500" style={{ wordBreak: "break-word" }}>
                        {getDynamicLabel(orderDetailsTranslation?.lblCostCenterExternalCustomer, "Costcenter/External customer")}
                      </span>
                    </div>
                  ) : (
                    <div className="col-sm-12 col-md-12 col-lg-3 col-xl-xl-3 txt-md mb-2 mt-3">
                      <span className="txt500" style={{ wordBreak: "break-word" }}>
                        {getDynamicLabel(orderDetailsTranslation?.lblCostCenter, "Costcenter")}
                      </span>
                    </div>
                  )}

                  <div className="col-sm-12 col-md-12 col-lg-9 col-xl-xl-9 txt-md mb-2">
                    {orderDetails?.Meeting !== null && orderDetails?.Meeting?.Id && (
                      <div className="d-flex mb-3">
                        <div className="form-check d-flex align-items-center me-3">
                          <div className="d-flex align-items-center">
                            <label className="form-check-label me-2" htmlFor="internal">
                              <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblInternal, "Internal")}</span>
                            </label>
                            <input
                              type="radio"
                              checked={invoiceInternal === true}
                              onChange={() => setInvoiceInternal(true)}
                              name="costcenter"
                              id="internal"
                            />
                          </div>
                        </div>

                        <div className="form-check d-flex align-items-center">
                          <div className="d-flex align-items-center">
                            <label className="form-check-label me-2" htmlFor="external">
                              <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblExternal, "External")}</span>
                            </label>
                            <input
                              type="radio"
                              checked={invoiceInternal === false}
                              onChange={() => setInvoiceInternal(false)}
                              name="costcenter"
                              id="external"
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="">
                      {invoiceInternal ? (
                        <div>
                          <div className="inputSec-icon">
                            {/* <Select
                              ref={costcenterRef}
                              openMenuOnFocus={true}
                              value={selectedDepartment > 0 && allDepartments?.length > 0 && [{ value: allDepartments?.find((d) => d?.Id === selectedDepartment)?.Id, label: allDepartments?.find((d) => d?.Id === selectedDepartment)?.Name }]}
                              onChange={(e) => setSelectedDepartment(Number(e.value))}
                              options={allDepartments?.length > 0
                                ? [{ value: 0, label: getDynamicLabel(orderDetailsTranslation?.lblSelectCostCenter, "Select Costcenter") },
                                ...allDepartments?.filter((d) => d?.Active)?.map((data) => ({ value: data?.Id, label: data?.Name }))
                                ]
                                : [{ value: 0, label: getDynamicLabel(orderDetailsTranslation?.lblSelectCostCenter, "Select Costcenter") }]
                              }
                              className="form-control p-0"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblSelectCostCenter, "Select Costcenter")}
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  border: "none",
                                  boxShadow: "none",
                                  padding: "8px 10px",
                                  borderRadius: 8,
                                }),
                              }}
                              components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: () => null
                              }}
                            /> */}
                            <div>
                              {renderDropdowns()}
                            </div>

                            <span onClick={() => costcenterRef.current?.focus()} className="custom-drop-down-span">
                              <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                            </span>
                          </div>

                          {/* <span className="txt-sm txt-gray p-1">
                            {allDepartments?.find((d) => d?.Id === selectedDepartment)?.ManagerName}
                          </span> */}
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-6 col-md-6 col-xl-6 col-xl-6 mb-3">
                            <CreatableSelect
                              isClearable
                              className="CreatableSelect"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblSearchCompany, "Search Company")}
                              value={invoiceExternalDetails?.CompanyName && [{ value: invoiceExternalDetails?.CompanyName, label: invoiceExternalDetails?.CompanyName }]}
                              onChange={(e) => {
                                const companyName = e ? e.value : "";
                                const filteredCompany = allCompanyResponse.filter((d) => d?.CompanyName === companyName)[0]

                                const updatedAddress = filteredCompany ? filteredCompany?.Address : "";
                                const updatedZip = filteredCompany ? filteredCompany?.Zip : "";
                                const updatedCVR = filteredCompany ? filteredCompany?.CVR : "";
                                const updatedAtt = filteredCompany ? filteredCompany?.Att : "";
                                const updatedMail = filteredCompany ? filteredCompany?.Mail : "";

                                setInvoiceExternalDetails((prev) => ({
                                  ...prev,
                                  CompanyName: companyName,
                                  Address: updatedAddress,
                                  Zip: updatedZip,
                                  CVR: updatedCVR,
                                  Att: updatedAtt,
                                  Mail: updatedMail
                                }));
                              }}
                              onInputChange={(event) => setCompanyQueryString(event)}
                              options={allCompanyResponse?.map((d) => ({ value: d?.CompanyName, label: d?.CompanyName }))}
                              components={{
                                IndicatorSeparator: () => null,
                                DropdownIndicator: () => null,
                                ClearIndicator: () => null,
                              }}
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  boxShadow: "none",
                                  borderRadius: 8,
                                  padding: "8px 10px",
                                  fontSize: "18px",
                                  border: "1px solid #e8ecef",
                                  outline: "none"
                                }),
                              }}
                            />
                          </div>

                          <div className="col-6 col-md-6 col-xl-6 col-xl-6 mb-3">
                            <input
                              type="text"
                              value={invoiceExternalDetails?.Address}
                              onChange={(e) => setInvoiceExternalDetails((prev) => ({ ...prev, Address: e.target.value }))}
                              className="form-control"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblAddress, "Address")}
                            />
                          </div>

                          <div className="col-4 col-md-2 col-lg-2 col-xl-2 mb-3">
                            <input
                              type="text"
                              value={invoiceExternalDetails?.Zip}
                              onChange={(e) => {
                                const value = e.target.value
                                if (value) {
                                  if (!isNaN(Number(value)) && Number(value) >= 0 && value?.length <= 8) {
                                    setInvoiceExternalDetails((prev) => ({ ...prev, Zip: value }))
                                  }
                                } else {
                                  setInvoiceExternalDetails((prev) => ({ ...prev, Zip: "" }))
                                }
                              }}
                              className="form-control"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblZip, "Zip")}
                            />
                          </div>

                          <div className="col-4 col-md-2 col-lg-2 col-xl-2 mb-3">
                            <input
                              type="text"
                              value={invoiceExternalDetails?.CVR ?? ""}
                              onChange={(e) => {
                                const value = e.target.value
                                if (value) {
                                  if (!isNaN(Number(value)) && Number(value) >= 0 && value?.length <= 13) {
                                    setInvoiceExternalDetails((prev) => ({ ...prev, CVR: value }))
                                  }
                                } else {
                                  setInvoiceExternalDetails((prev) => ({ ...prev, CVR: "" }))
                                }
                              }}
                              className={`form-control ${invoiceExternalDetails?.CVR && (invoiceExternalDetails?.CVR?.length !== 8 && invoiceExternalDetails?.CVR?.length !== 13) ? "border-danger" : ""}`}
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblCvrEanNumber, "CVR/EAN-Number")}
                            />
                            {invoiceExternalDetails?.CVR && (invoiceExternalDetails?.CVR?.length !== 8 && invoiceExternalDetails?.CVR?.length !== 13) && (
                              <span className="text-danger">{getDynamicLabel(orderDetailsTranslation?.lblCvrEanNumberEightOrThirteen, "CVR or EAN Number must be either 8 or 13 digits")}</span>
                            )}
                          </div>

                          <div className="col-4 col-md-2 col-lg-2 col-xl-2 mb-3">
                            <input
                              type="text"
                              value={invoiceExternalDetails?.Att}
                              onChange={(e) => setInvoiceExternalDetails((prev) => ({ ...prev, Att: e.target.value }))}
                              className="form-control"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblATT, "ATT")}
                            />
                          </div>

                          <div className="col-12 col-md-6 col-xl-6 col-xl-6 mb-3">
                            <input
                              type="text"
                              value={invoiceExternalDetails?.Mail}
                              onChange={(e) => setInvoiceExternalDetails((prev) => ({ ...prev, Mail: e.target.value }))}
                              className="form-control"
                              placeholder={getDynamicLabel(orderDetailsTranslation?.lblMail, "Mail")}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Catering Fields */}
                {allCateringFields?.length > 0 && allCateringFields?.map((field, fieldIndex) => (
                  <div key={fieldIndex} className="row list catering-field">
                    <div className="col-3 d-flex align-items-center txt-md mt-3">
                      <span className="txt500">
                        {field?.Title ?? ""}
                        {field?.Required && <span className="text-danger ms-1">*</span>}
                      </span>
                    </div>

                    {field?.Type?.Title?.toLocaleLowerCase() === "text" ? (
                      <div className="col-9 d-flex gap-2 txt-md mt-3">
                        <input
                          type="text"
                          value={fieldValues?.find((item) => item?.FieldId === field?.Id)?.Value ?? ""}
                          onChange={(e) => handleFieldChange(field.Id, e.target.value)}
                          placeholder={field?.PlaceholderText ?? ""}
                          required={field?.Required ?? false}
                          className="rounded-2 form-control card-input m-0"
                        />

                        {field?.HelpText && (
                          <i
                            className="bi bi-info-circle app-theme-color d-flex align-items-center"
                            style={{ fontSize: "20px", cursor: "pointer" }}
                            data-tooltip-id={`helpText-${fieldIndex}`}
                            data-tooltip-html={field?.HelpText ?? ""}
                            data-tooltip-place="top"
                          />
                        )}

                        <Tooltip id={`helpText-${fieldIndex}`} style={{ zIndex: 1000, maxWidth: "300px" }} />
                      </div>
                    ) : (
                      <input
                        type="number"
                        value={fieldValues?.find((item) => item?.FieldId === field?.Id)?.Value ?? 0}
                        min={0}
                        onChange={(e) => handleFieldChange(field.Id, Number(e.target.value))}
                        required={field?.Required ?? false}
                        className="form-control card-input mb-0"
                      />
                    )}
                  </div>
                ))}

                {/* DeliveryMethod */}
                {orderDetails?.Meeting !== null && orderDetails?.Meeting?.Id ? (
                  <div className="row list mt-3">
                    <div className="col-3 txt-md mb-2 align-self-center">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblDeliveryMethod, "Delivery Method")}</span>
                    </div>

                    <div className="col-9 txt-md mb-2">
                      <div className="inputSec-icon">
                        <Select
                          ref={deliveryRef} openMenuOnFocus={true}
                          value={selectedDeliveryMethod && [{ value: selectedDeliveryMethod, label: selectedDeliveryMethod }]}
                          onChange={(e) => setSelectedDeliveryMethod(e.value)}
                          options={[{ value: "Delivery", label: getDynamicLabel(orderDetailsTranslation?.lblDelivery, "Delivery") }, { value: "Pickup", label: getDynamicLabel(orderDetailsTranslation?.lblPickup, "Pickup") }]}
                          className="form-control p-0" placeholder={getDynamicLabel(orderDetailsTranslation?.lblSelectDeliveryMethod, "Select Delivery Method")}
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              border: "none",
                              boxShadow: "none",
                              padding: "8px 10px",
                              borderRadius: 8,
                            }),
                          }}
                          components={{
                            IndicatorSeparator: () => null,
                            DropdownIndicator: () => null
                          }}
                          isDisabled={orderDetails?.Meeting === null || !orderDetails?.Meeting}
                        />
                        <span onClick={() => deliveryRef.current.focus()} className="custom-drop-down-span">
                          <img className="custom-drop-down-image" alt="icon-user" src={iconArrow} />
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row list mt-3">
                    <div className="txt-md mb-2 mt-2 col-3">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblDelivery, "Delivery")}<span className="required">*</span></span>
                    </div>

                    <div className="txt-md mb-2 mt-2 col-3">
                      {selectedDeliveryMethod}
                    </div>

                    {/* <div className="txt-md mb-2 mt-2 col-3 text-center align-self-center">
                      <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblPickupTime, "Pickup Time")}<span className="required">*</span></span>
                    </div>

                    <div className="txt-md mb-2 col-3">
                      <ReactDatePicker
                        type="time"
                        selected={moment(pickupTime, "HH:mm").toDate()}
                        onChange={(time) => {
                          setPickUpTime(moment(time).format("HH:mm"))
                        }}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={5}
                        className="form-control"
                        dateFormat="HH:mm"
                        timeFormat="HH:mm"
                        minDate={new Date()}
                        maxTime={moment().endOf("day").toDate()}
                        minTime={moment().format("YYYY-MM-DD") === moment(inputDate).format("YYYY-MM-DD") ?
                          moment().add(30, "m").toDate() :
                          moment().startOf("day").toDate()}
                      />
                    </div> */}
                  </div>
                )}

                <div className="row list mt-3 ">
                  {orderDetails?.Meeting !== null && orderDetails?.Meeting?.Id && (
                    <>
                      {/* Internal */}
                      <div className="col-3 txt-md mb-2 mt-2 align-self-center">
                        <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblInternal, "Internal")}</span>
                      </div>
                      <div className="col-3 txt-md mb-2">
                        <input
                          type="number"
                          min={minInternalAttendees}
                          max={maxInternalAttendees}
                          className="form-control form-control2"
                          placeholder={getDynamicLabel(orderDetailsTranslation?.lblItem, "Item")}
                          value={updatedInternalAttendees}
                          onChange={(e) => {
                            setUpdatedInternalAttendees(
                              e.target.value <= minInternalAttendees
                                ? minInternalAttendees
                                : e.target.value >= maxInternalAttendees
                                  ? maxInternalAttendees
                                  : Number(e.target.value)
                            )
                          }}
                        />
                      </div>

                      {/* External */}
                      <div className="col-3 txt-md mb-2 mt-2 text-center align-self-center">
                        <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblExternal, "External")}</span>
                      </div>
                      <div className="col-3 txt-md mb-2">
                        <input
                          type="number"
                          min={minExternalAttendees}
                          max={maxExternalAttendees}
                          className="form-control form-control2"
                          placeholder={getDynamicLabel(orderDetailsTranslation?.lblItem, "Item")}
                          value={updatedExternalAttendees}
                          onChange={(e) => {
                            setUpdatedExternalAttendees(
                              e.target.value <= minExternalAttendees
                                ? minExternalAttendees
                                : e.target.value >= maxExternalAttendees
                                  ? maxExternalAttendees
                                  : Number(e.target.value)
                            )
                          }}
                        />
                      </div>
                    </>
                  )}

                  {/* Shared Comment */}
                  <div className="txt-md mb-2  mt-3">
                    <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblSharedComment, "Shared Comment")}</span>
                    {/* <textarea
                      className="form-control mt-2"
                      rows={3}
                      value={updatedSharedComment}
                      onChange={(e) => setUpdatedSharedComment(e.target.value)}
                    /> */}
                    <SunEditor
                      lang="en"
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["formatBlock"],
                          ["bold", "underline", "removeFormat"],
                          // ["font"],
                          ["hiliteColor", "fontColor"],
                          ["list", "align", "outdent", "indent"],
                          // ["table"],
                          // ["link", "image", "video"],
                          // ["fullScreen", "codeView"],
                          // ["codeView"],
                        ], // Or Use buttonList.basic, buttonList.complex Or buttonList.formatting Provided by SunEditor.
                        font: ["Arial", "Arial Black", "Open Sans", "Cosmic Sans Ms", "Courier New", "Helvetica", "Impact", "Tahoma", "Time New Roman", "Verdana"] // Comment This For Default Options.
                      }}
                      setContents={updatedSharedComment}
                      onChange={(content) => setUpdatedSharedComment(content)}
                      setDefaultStyle="font-family: Open Sans"
                      placeholder={getDynamicLabel(orderDetailsTranslation?.lblSharedComment, "Shared Comment")}
                    />
                  </div>

                  {/* Internal Comment */}
                  <div className="txt-md mb-4 mt-3">
                    <span className="txt500">{getDynamicLabel(orderDetailsTranslation?.lblInternalComment, "Internal Comment")}</span>
                    {/* <textarea
                      className="form-control mt-2"
                      rows={3}
                      value={updatedInternalComment}
                      onChange={(e) => setUpdatedInternalComment(e.target.value)}
                    /> */}
                    <SunEditor
                      lang="en"
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["formatBlock"],
                          ["bold", "underline", "removeFormat"],
                          // ["font"],
                          ["hiliteColor", "fontColor"],
                          ["list", "align", "outdent", "indent"],
                          // ["table"],
                          // ["link", "image", "video"],
                          // ["fullScreen", "codeView"],
                          // ["codeView"],
                        ], // Or Use buttonList.basic, buttonList.complex Or buttonList.formatting Provided by SunEditor.
                        font: ["Arial", "Arial Black", "Open Sans", "Cosmic Sans Ms", "Courier New", "Helvetica", "Impact", "Tahoma", "Time New Roman", "Verdana"] // Comment This For Default Options.
                      }}
                      setContents={updatedInternalComment}
                      onChange={(content) => setUpdatedInternalComment(content)}
                      setDefaultStyle="font-family: Open Sans"
                      placeholder={getDynamicLabel(orderDetailsTranslation?.lblInternalComment, "Internal Comment")}
                    />
                  </div>
                </div>
              </div>
            )}
          </section>

          {editOrderProductStatus && (
            <div className="row">
              <div className="col-12">
                <button
                  id="btnOuterSave"
                  className="btn btn-primary btn-lg btn-full btnOuterSave"
                  onClick={() => {
                    if (orderDetails?.Meeting !== null && orderDetails?.Meeting?.Id) {
                      SaveCanteenOrder()
                    } else {
                      SaveWithoutMeeting()
                    }
                  }}
                >
                  {getDynamicLabel(orderDetailsTranslation?.btnSave, "Save")}
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </>
  )
}
